__turbopack_context__.v({
  "banner": "Banner-module-scss-module__7eA2ka__banner",
  "bannerContent": "Banner-module-scss-module__7eA2ka__bannerContent",
});
